import React from 'react'
import { Close } from 'components/icons'
import { ButtonRounded, WModal } from 'components/atoms'
import styles from './Modal.module.sass'

interface Props {
  id: string
  title?: string
  ariaLabel?: string
  ariaLabelledby?: string
  open: boolean
  onClose?: (v?: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => void
  closeButton?: boolean
  className?: string
  closeClassName?: string
  children?: React.ReactNode
}

const Modal = (props: Props) => {
  const {
    id,
    open = false,
    onClose = undefined,
    closeButton = false,
    title = undefined,
    ariaLabel = undefined,
    ariaLabelledby = undefined,
    className = '',
    closeClassName = '',
    children = null,
  } = props

  return (
    <WModal
      id={id}
      open={open}
      ariaLabel={ariaLabel}
      ariaLabelledby={ariaLabelledby || title ? `${id}_title` : undefined}
      onClose={onClose}
      className={`${styles.root} ${className}`}
    >
      {closeButton && onClose && (
        <ButtonRounded
          icon={<Close />}
          backgroundTheme="dark"
          size="xs"
          className={`${styles.close} ${closeClassName}`}
          onClick={onClose}
        />
      )}
      {children}
    </WModal>
  )
}

export default Modal
